<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu danh sách kiểm kê tài sản</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-unit-type v-model="searchForm.syncUnitType"></sync-unit-type>
                                </b-form-group>
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" :options="listSyncSourceTypes"
                                                      allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col sm="6">
                                <b-form-group label="Hình thức kiểm kê:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.inventoryForm" :options="inventoryForms" allowClear="true" placeholder="--- Tất cả ---" class="no-padding"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Trạng thái kiểm kê:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.inventoryStatus" :options="inventoryStatuses" allowClear="true" placeholder="--- Tất cả ---" class="no-padding"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày kiểm kê từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.syncStartDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.syncEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Số biên bản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.code" placeholder="Nhập số biên bản kiểm kê ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                            <!--<b-col md="6">
                                <b-form-group label="Tên đợt kiểm kê:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.name" placeholder="Nhập tên ..."></b-form-input>
                                </b-form-group>
                            </b-col>-->
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col md="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :isRowSelectable="isDataOwner"
                            dataUrl="data/asset-inventories"
                            gridName="Danh sách kiểm kê tài sản"
                            ref="assetInventoriesTable">
                        <!--<template v-slot:actions v-if="hasDeletePermission">
                            <b-button size="md" @click.stop="removeSelected"
                                      v-if="isAdmin" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>
                        </template>-->
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.item.syncSourceType) }}
                        </template>
                        <template v-slot:cell(inventoryDate)="row">
                            {{ row.item.inventoryDate | formatDate }}
                        </template>
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(inventoryForm)="row">
                            {{ getInventoryForm(row.item) }}
                        </template>
                        <template v-slot:cell(status)="row">
                            {{ getInventoryStatuses(row.item.status) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewAssetInventory'])" size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="isDataOwner(row.item) && isAdmin" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'
    import { mapState } from 'vuex'

    export default {
        name: 'ListSyncedAssetInventories',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    code: null,
                    name: null,
                    assetTypeId: null,
                    startDate: null,
                    endDate: new Date().formatDate(),
                    syncStartDate: null, //new Date().firstDayOfMonth().formatDate(),
                    syncEndDate: new Date().formatDate(),
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    syncSourceType: this.getSyncSourceTypeCache([1, 2, 101, 102]),
                    inventoryForm: null,
                    inventoryStatus: null,
                    syncUnitType: 0,
                },
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Số biên bản', sortable: true, sortDirection: 'asc' },
                        //{ key: 'name', label: 'Tên đợt kiểm kê', sortable: true, sortDirection: 'asc' },
                        { key: 'inventoryDate', label: 'Ngày kiểm kê', sortable: true },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: true },
                        { key: 'unitName', label: 'Đơn vị kiểm kê', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        { key: 'syncUnitName', label: 'Đơn vị đồng bộ', sortable: true, tdAttr: (key, value, item) => ({ title: item.syncUnitFullName }) },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true, sortDirection: 'asc' },
                        //{ key: 'inventoryForm', label: 'Hình thức kiểm kê', sortable: true, sortDirection: 'asc' },
                        //{ key: 'status', label: 'Trạng thái', sortable: true },
                    ],
                    sortBy: 'syncDate',
                    sortDesc: true
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            ...mapState({
                inventoryForms: (state) => state.common.inventoryForms,
                inventoryStatuses: (state) => state.common.inventoryStatuses,
                listSyncSourceTypes: (state) => state.common.listSyncSourceTypes.filter(x => x.assetInventory)
            }),
            hasDeletePermission() {
                return this.authorize(['ManageAssetInventory']);
            }
        },
        created() {
            //this.searchForm.unitId = this.$store.state.identity.unitId;
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.assetInventoriesTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.assetInventoriesTable.refresh();
            },
            isDataOwner(row) {
                return this.authorize(['ManageAssetInventory'], row.syncUnitId);
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa biên bản kiểm kê tài sản này?')) {
                    this.$services.delete(`data/asset-inventories/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa biên bản kiểm kê tài sản thành công');
                        vm.search();
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.assetInventoriesTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các biên bản kiểm kê tài sản này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/asset-inventories?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các biên bản kiểm kê tài sản thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn biên bản kiểm kê tài sản cần xóa');
                }
            },
            getInventoryForm(item) {
                if (!isNaN(item.inventoryForm)) {
                    var form = this.inventoryForms[item.inventoryForm - 1];
                    //if (item.inventoryForm == 4) {
                    //    return item.inventoryFormOther ?? (form ? form.text : '');
                    //} else {
                    return (form ? form.text : '');
                    //}
                }
            },
            getInventoryStatuses(value) {
                if (!isNaN(value)) {
                    var status = this.inventoryStatuses[value - 1];
                    return status ? status.text : '';
                }
            }
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
